import { Action, createAsyncThunk, createSlice, PayloadAction, ThunkAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import IOpportunitiesResponseModel, { IOpportunityDetailItemModel, IUserResponseModel } from '../models/IOpportunitiesAPIModel';
import { GenericState } from './ISliceInterfaces';
import axios from '../utils/APIUtils';
import { OPPORTUNITIES_API_PATHS } from '../constants/constants';
import { getallOpportunities, getStatusPills } from './allOpportunitySlice';
import { UserManager } from '@forge/sso-client/dist';
import { isAks } from 'src/utils/properties/UrlsAndEnvProperties';
import { IAOPTargetsStatusItemModel, IKPIModel } from '../models/IUserProfileModel';
import { getAopTargetsStatus, IgetAopTargetStatusArgs } from './userProfileSlice';

export const initialState = {
  cards: { status: 'idle' } as GenericState<IOpportunitiesResponseModel>,
  summaryCards: { status: 'idle'} as GenericState<any>,
  actionStatus: 0
};

/** Get opportunities */
export const getOpportunities = createAsyncThunk('opportunities/getOpportunities', async (maxCount: number = 20) => {
  const response = await axios.get<IOpportunitiesResponseModel>(OPPORTUNITIES_API_PATHS.opportunities, { params: { limit: maxCount } });
  return response.data;
});
/** Get Power User summary */
export const getSummaryModule = createAsyncThunk('opportunities/getSummaryModule', async () => {
  const response = await axios.get<any>(OPPORTUNITIES_API_PATHS.summaryModule); //TODO: Define proper type
  return response.data;
});



/** Accepts or rejects an opportunity */
export const updateOpportunityACP = (insightId: number, data: IUserResponseModel):ThunkAction<any,RootState,unknown,Action<string>> => dispatch => {
  return new Promise<void>((resolve,reject) => {   
    axios.post(`${OPPORTUNITIES_API_PATHS.acpUserResponse}/${insightId}/acp-user-response`, {
        'user_response': data
      }).then(() => {
          dispatch(removeOpportunityCard(insightId));
          // if ( data.user_response === 'accept' || data.user_response === 'reject' ) {
          //   dispatch(getAopTargetsStatus());
          // } else if (data.user_response === 'realized') {
          //   let getAopTargetStatusArgs: IgetAopTargetStatusArgs = {showToast: true, toastType: 'realize', kpiId: data.kpi_id};
          //   dispatch(getAopTargetsStatus(getAopTargetStatusArgs));
          // }
          // if ( data.user_response === 'accept' || data.user_response === 'reject' || data.user_response === 'realized' || data.user_response === 'reopen') {
          //   // trigger all opportunities API and store in the store
          //   dispatch(getallOpportunities());
          //   dispatch(getStatusPills());
          //   dispatch(getHistoryOpportunities())
          //   dispatch(getHistoryPills())
          // }
          resolve();
      }).catch(() => reject());
  });
};




/** Accepts or rejects an opportunity */
export const updateOpportunity = (insightId: number, data: IUserResponseModel): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
  return new Promise<void>((resolve, reject) => {
    axios.post(`${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/user-response`, {
      'user_response': {...data, 'checklist_response': null }
    }).then((response:any) => {
      dispatch(removeOpportunityCard(insightId));
      if (data.user_response === 'accept' || data.user_response === 'reject') {
        // dispatch(getAopTargetsStatus());
      } else if (data.user_response === 'realized') {
        // let getAopTargetStatusArgs: IgetAopTargetStatusArgs = {showToast: true, toastType: 'realize', kpiId: data.kpi_id};
        // dispatch(getAopTargetsStatus(getAopTargetStatusArgs));
      }
      if (data.user_response === 'accept' || data.user_response === 'reject' || data.user_response === 'realized' || data.user_response === 'reopen') {
        // trigger all opportunities API and store in the store
        dispatch(getallOpportunities());
        dispatch(getStatusPills());
      }
      resolve(response);
    }).catch(() => reject());
  });
};

export const updateTrackingOpportunity = (insightId: number, data: IUserResponseModel): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
  return new Promise<void>(async (resolve, reject) => {
    const userManager = UserManager.getInstance();
        const user = (await userManager.getUser());
    axios.post(`${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/submit-tracking`, 
      data,{ headers: {
        'x-id-token': `Bearer ${isAks() ? sessionStorage.getItem("idToken") : (user)?.id_token}`
    }
    }).then((response:any) => {
      dispatch(removeOpportunityCard(insightId));
        dispatch(getallOpportunities());
        dispatch(getStatusPills());
      resolve(response);
    }).catch((err) => reject(err));
  });
};

export const opportunitiesSlice = createSlice({
  name: 'opportunities',
  initialState,
  reducers: {
    removeOpportunityCard: (state, action: PayloadAction<number>) => {
      const newstate = state.cards.data?.opportunity_detail.filter((item: IOpportunityDetailItemModel) => item.insight_id !== action.payload);
      if (newstate && state.cards.data) {
        state.cards.data.opportunity_detail = newstate;
      }
    },
    updateActionStatus: (state) => {
       state.actionStatus +=1;
    }

  },
  
  extraReducers: builder => {
    builder.addCase(getOpportunities.pending, (state) => {
      state.cards.status = 'loading';
    });
    builder.addCase(getOpportunities.fulfilled, (state, action) => {
      state.cards.status = 'finished';
      state.cards.data = action.payload;
    });
    builder.addCase(getOpportunities.rejected, (state) => {
      state.cards.status = 'error';
    });
    builder.addCase(getSummaryModule.pending, (state) => {
      state.summaryCards.status = 'loading';
    });
    builder.addCase(getSummaryModule.fulfilled, (state, action) => {
      state.summaryCards.status = 'finished';
      state.summaryCards.data = action.payload;
    });
    builder.addCase(getSummaryModule.rejected, (state) => {
      state.summaryCards.status = 'error';
    });
  }
});

export const { removeOpportunityCard, updateActionStatus } = opportunitiesSlice.actions;

export const getOpportunitiesSelector = (state: RootState) => state.opportunities.cards;

export const getSummaryModuleSelector = (state: RootState) => state.opportunities.summaryCards;

export  const getActionStatus = (state: RootState) => state.opportunities?.actionStatus;

export default opportunitiesSlice.reducer;
